export default ({
  SECTION : 'create',
  CONTEXT_FORMENGINE_DRAFT_CREATE                 : 'formEngine:draft:create',
  CONTEXT_FORMENGINE_DRAFT_UPDATE                 : 'formEngine:draft:update',

  MODAL_FORMS_CREATE_FIELD                        : 'modal:formEngine:create:field',
  MODAL_FORMS_UPDATE_FIELD                        : 'modal:formEngine:update:field',
  MODAL_FORMS_SCORES_MATH                         : 'modal:formEngine:scores',
  MODAL_FORMS_GRAPHIC_CONFIG                      : 'modal:formEngine:graphic:config',
  MODAL_FORMS_PREVIEW                             : 'modal:formEngine:preview',
  MODAL_FORMS_FIELD_DESIGN                        : 'modal:formEngine:design',

  FORMS_CREATE_GET_LIST_CARD                      : 'FORMS_CREATE_GET_LIST_CARD',

  FORMS_CREATE_SET_FIELD_DROP_END                 : 'FORMS_CREATE_SET_FIELD_DROP_END',
  FORMS_CREATE_SET_MODULE_DROP_END                : 'FORMS_CREATE_SET_MODULE_DROP_END',
  FORMS_CREATE_SET_SECTION_DROP_END               : 'FORMS_CREATE_SET_SECTION_DROP_END',

  FORMS_CREATE_RESET_DYNAMIC_FORMS                : 'FORMS_CREATE_RESET_DYNAMIC_FORMS',
  FORMS_CREATE_CHANGE_INPUT_HEADER                : 'FORMS_CREATE_CHANGE_INPUT_HEADER',
  FORMS_CREATE_CHANGE_INPUT_SECTIONS              : 'FORMS_CREATE_CHANGE_INPUT_SECTIONS',
  FORMS_CREATE_CHANGE_INPUT_MODULES               : 'FORMS_CREATE_CHANGE_INPUT_MODULES',

  FORMS_CREATE_REMOVED_FIELD                      : 'FORMS_CREATE_REMOVED_FIELD',
  FORMS_CREATE_REMOVED_MODULE                     : 'FORMS_CREATE_REMOVED_MODULE',
  FORMS_CREATE_REMOVED_SECTION                    : 'FORMS_CREATE_REMOVED_SECTION',

  FORMS_CREATE_GET_LIST_FIELDS_FETCH_REQUEST      : 'FORMS_CREATE_GET_LIST_FIELDS_FETCH_REQUEST',
  FORMS_CREATE_GET_LIST_FIELDS_FETCH_SUCCESS      : 'FORMS_CREATE_GET_LIST_FIELDS_FETCH_SUCCESS',
  FORMS_CREATE_GET_LIST_FIELDS_FETCH_ERROR        : 'FORMS_CREATE_GET_LIST_FIELDS_FETCH_ERROR',

  FORMS_CREATE_GET_MODEL_BY_ID_FETCH_REQUEST      : 'FORMS_CREATE_GET_MODEL_BY_ID_FETCH_REQUEST',
  FORMS_CREATE_GET_MODEL_BY_ID_FETCH_SUCCESS      : 'FORMS_CREATE_GET_MODEL_BY_ID_FETCH_SUCCESS',
  FORMS_CREATE_GET_MODEL_BY_ID_FETCH_ERROR        : 'FORMS_CREATE_GET_MODEL_BY_ID_FETCH_ERROR',

  FORMS_CREATE_SAVE_VERSION_FIELD_FETCH_REQUEST   : 'FORMS_CREATE_SAVE_VERSION_FIELD_FETCH_REQUEST',
  FORMS_CREATE_SAVE_VERSION_FIELD_FETCH_SUCCESS   : 'FORMS_CREATE_SAVE_VERSION_FIELD_FETCH_SUCCESS',
  FORMS_CREATE_SAVE_VERSION_FIELD_FETCH_ERROR     : 'FORMS_CREATE_SAVE_VERSION_FIELD_FETCH_ERROR',

  FORMS_CREATE_SET_SEARCH_FIELDS_TAB              : 'FORMS_CREATE_SET_SEARCH_FIELDS_TAB',
  FORMS_CREATE_SET_SEARCH_FIELDS_MANAGER_TAB      : 'FORMS_CREATE_SET_SEARCH_FIELDS_MANAGER_TAB',
  
  FORMS_CREATE_SET_NEW_SECTION                    : 'FORMS_CREATE_SET_NEW_SECTION',
  FORMS_CREATE_SET_NEW_MODULES                    : 'FORMS_CREATE_SET_NEW_MODULES',
  FORMS_CREATE_SET_NEW_FIELDS_IDS                 : 'FORMS_CREATE_SET_NEW_FIELDS_IDS',
  FORMS_CREATE_SET_NEW_DYNAMIC_FIELDS             : 'FORMS_CREATE_SET_NEW_DYNAMIC_FIELDS',

  FORMS_CREATE_MODAL_OPEN_VISIBILE                : 'FORMS_CREATE_MODAL_OPEN_VISIBILE',
  FORMS_CREATE_MODAL_CLOSE_VISIBILE               : 'FORMS_CREATE_MODAL_CLOSE_VISIBILE',

  FORMS_CREATE_MODAL_CHANGE_INPUT                 : 'FORMS_CREATE_MODAL_CHANGE_INPUT',
  FORMS_CREATE_MODAL_CHANGE_INPUT_SIZE            : 'FORMS_CREATE_MODAL_CHANGE_INPUT_SIZE',

  FORMS_CREATE_MODAL_SAVE_FIELD                   : 'FORMS_CREATE_MODAL_SAVE_FIELD',

  FORMS_CREATE_SET_FIELD_MODEL_VERSION            : 'FORMS_CREATE_SET_FIELD_MODEL_VERSION',

  FORM_CREATE_SAVE_FETCH_REQUEST                  : 'FORM_CREATE_SAVE_FETCH_REQUEST',
  FORM_CREATE_SAVE_FETCH_SUCCESS                  : 'FORM_CREATE_SAVE_FETCH_SUCCESS',
  FORM_CREATE_SAVE_FETCH_ERROR                    : 'FORM_CREATE_SAVE_FETCH_ERROR',

  FORMS_CREATE_CHANGE_ATTACH_PATIENT_MODEL        : 'FORMS_CREATE_CHANGE_ATTACH_PATIENT_MODEL',

  FORM_CREATE_GET_DRAFT_BY_ID_FETCH_REQUEST       : 'FORM_CREATE_GET_DRAFT_BY_ID_FETCH_REQUEST',
  FORM_CREATE_GET_DRAFT_BY_ID_FETCH_SUCCESS       : 'FORM_CREATE_GET_DRAFT_BY_ID_FETCH_SUCCESS',
  FORM_CREATE_GET_DRAFT_BY_ID_FETCH_ERROR         : 'FORM_CREATE_GET_DRAFT_BY_ID_FETCH_ERROR',

  FORM_CREATE_SAVE_DRAFT_FETCH_REQUEST            : 'FORM_CREATE_SAVE_DRAFT_FETCH_REQUEST',
  FORM_CREATE_SAVE_DRAFT_FETCH_SUCCESS            : 'FORM_CREATE_SAVE_DRAFT_FETCH_SUCCESS',
  FORM_CREATE_SAVE_DRAFT_FETCH_ERROR              : 'FORM_CREATE_SAVE_DRAFT_FETCH_ERROR',

  FORMS_CREATE_SET_BUILD_DRAFT_BY_ID              : 'FORMS_CREATE_SET_BUILD_DRAFT_BY_ID',

  FORMS_CREATE_SET_UPDATE_FIELD_BY_ID             : 'FORMS_CREATE_SET_UPDATE_FIELD_BY_ID',
  FORMS_CREATE_CHANGE_INPUT_DATA_FORMS            : 'FORMS_CREATE_CHANGE_INPUT_DATA_FORMS',
  FORMS_CREATE_GET_LIST_FIELDS_MANAGER_FETCH_SUCCESS:   'FORMS_CREATE_GET_LIST_FIELDS_MANAGER_FETCH_SUCCESS',
  MODAL_FORMS_CONFIG_FIELD_GRAPHIC: 'MODAL_FORMS_CONFIG_FIELD_GRAPHIC',
  MODALFIELDS_SET_CONFIG_FIELD: 'MODALFIELDS_SET_CONFIG_FIELD',
  FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_REQUEST: 'FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_REQUEST',
  FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_SUCCESS: 'FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_SUCCESS',
  FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_ERROR: 'FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_ERROR',
  FORMS_CREATE_GET_IMAGE_FORM_FIELD_SAVED_FETCH_SUCCESS: 'FORMS_CREATE_GET_IMAGE_FORM_FIELD_SAVED_FETCH_SUCCESS',

  FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_REQUEST      : 'FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_REQUEST',
  FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_SUCCESS      : 'FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_SUCCESS',
  FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_ERROR        : 'FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_ERROR',
  FORMS_CREATE_UPLOAD_DOCUMENT_PROGRESS           : 'FORMS_CREATE_UPLOAD_DOCUMENT_PROGRESS',
  FORMS_CREATE_EXTRACT_TEXT_FETCH_REQUEST         : 'FORMS_CREATE_EXTRACT_TEXT_FETCH_REQUEST',
  FORMS_CREATE_EXTRACT_TEXT_FETCH_SUCCESS         : 'FORMS_CREATE_EXTRACT_TEXT_FETCH_SUCCESS',
  FORMS_CREATE_EXTRACT_TEXT_FETCH_ERROR           : 'FORMS_CREATE_EXTRACT_TEXT_FETCH_ERROR',
  FORMS_CREATE_JOB_STREAM_CONNECTED               : 'FORMS_CREATE_JOB_STREAM_CONNECTED',
  FORMS_CREATE_JOB_STREAM_UPDATE                  : 'FORMS_CREATE_JOB_STREAM_UPDATE',
  FORMS_CREATE_JOB_STREAM_ERROR                   : 'FORMS_CREATE_JOB_STREAM_ERROR',
  FORMS_CREATE_JOB_STREAM_CLOSED                  : 'FORMS_CREATE_JOB_STREAM_CLOSED',
  FORMS_CREATE_PROCESS_EXTRACTED_FORM_DATA        : 'FORMS_CREATE_PROCESS_EXTRACTED_FORM_DATA',
  FORMS_CREATE_CHANGE_IS_BLOCK_SAVE                : 'FORMS_CREATE_CHANGE_IS_BLOCK_SAVE',
  FORMS_CREATE_GET_FIELDS_LAST_VERSION_BY_FIELD_MODEL_IDS_FETCH_SUCCESS: 'FORMS_CREATE_GET_FIELDS_LAST_VERSION_BY_FIELD_MODEL_IDS_FETCH_SUCCESS',
  FORMS_CREATE_REPLACE_BY_SIMILAR_FIELD_FETCH_SUCCESS: 'FORMS_CREATE_REPLACE_BY_SIMILAR_FIELD_FETCH_SUCCESS',

  // FormBuilder Chat Constants
  FORMBUILDER_CHAT_CREATE_SESSION_REQUEST         : 'FORMBUILDER_CHAT_CREATE_SESSION_REQUEST',
  FORMBUILDER_CHAT_CREATE_SESSION_SUCCESS         : 'FORMBUILDER_CHAT_CREATE_SESSION_SUCCESS',
  FORMBUILDER_CHAT_CREATE_SESSION_FAILURE         : 'FORMBUILDER_CHAT_CREATE_SESSION_FAILURE',
  
  FORMBUILDER_CHAT_SEND_MESSAGE_REQUEST           : 'FORMBUILDER_CHAT_SEND_MESSAGE_REQUEST',
  FORMBUILDER_CHAT_SEND_MESSAGE_SUCCESS           : 'FORMBUILDER_CHAT_SEND_MESSAGE_SUCCESS',
  FORMBUILDER_CHAT_SEND_MESSAGE_FAILURE           : 'FORMBUILDER_CHAT_SEND_MESSAGE_FAILURE',
  
  FORMBUILDER_CHAT_FINISH_SESSION_REQUEST         : 'FORMBUILDER_CHAT_FINISH_SESSION_REQUEST',
  FORMBUILDER_CHAT_FINISH_SESSION_SUCCESS         : 'FORMBUILDER_CHAT_FINISH_SESSION_SUCCESS',
  FORMBUILDER_CHAT_FINISH_SESSION_FAILURE         : 'FORMBUILDER_CHAT_FINISH_SESSION_FAILURE',
  
  FORMBUILDER_CHAT_LIST_SESSIONS_REQUEST          : 'FORMBUILDER_CHAT_LIST_SESSIONS_REQUEST',
  FORMBUILDER_CHAT_LIST_SESSIONS_SUCCESS          : 'FORMBUILDER_CHAT_LIST_SESSIONS_SUCCESS',
  FORMBUILDER_CHAT_LIST_SESSIONS_FAILURE          : 'FORMBUILDER_CHAT_LIST_SESSIONS_FAILURE',
  
  FORMBUILDER_CHAT_GET_SESSION_REQUEST            : 'FORMBUILDER_CHAT_GET_SESSION_REQUEST',
  FORMBUILDER_CHAT_GET_SESSION_SUCCESS            : 'FORMBUILDER_CHAT_GET_SESSION_SUCCESS',
  FORMBUILDER_CHAT_GET_SESSION_FAILURE            : 'FORMBUILDER_CHAT_GET_SESSION_FAILURE',
  
  FORMBUILDER_CHAT_SET_WEBSOCKET_MESSAGE          : 'FORMBUILDER_CHAT_SET_WEBSOCKET_MESSAGE',
  FORMBUILDER_CHAT_SET_TYPING                     : 'FORMBUILDER_CHAT_SET_TYPING',
  FORMBUILDER_CHAT_ADD_MESSAGE                    : 'FORMBUILDER_CHAT_ADD_MESSAGE',
  FORMBUILDER_CHAT_UPDATE_FORM_PREVIEW            : 'FORMBUILDER_CHAT_UPDATE_FORM_PREVIEW',
  FORMBUILDER_CHAT_WEBSOCKET_CONNECTED            : 'FORMBUILDER_CHAT_WEBSOCKET_CONNECTED',
  FORMBUILDER_CHAT_WEBSOCKET_DISCONNECTED         : 'FORMBUILDER_CHAT_WEBSOCKET_DISCONNECTED',
  FORMBUILDER_CHAT_RESET                          : 'FORMBUILDER_CHAT_RESET',
  FORMBUILDER_CHAT_BACKUP_FORM                    : 'FORMBUILDER_CHAT_BACKUP_FORM',
  FORMBUILDER_CHAT_RESTORE_FORM                   : 'FORMBUILDER_CHAT_RESTORE_FORM',
});